import http from '@/helpers/Http'
export default {
    namespaced: true,
    state: {
        user: null,
        showOTPModal: false,
        sessionExpired: false,
    },
    getters: {
        user: state => state.user,
        showOTPModal: state => state.showOTPModal,
        sessionExpired: state => state.sessionExpired,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        login(state, payload) {
            state.user = payload.user
        },
        logout(state) {
            state.user = null
        },
        upgrade(state) {
            state.user.is_premium = true
        },
        toggleOTPModal(state) {
            state.showOTPModal = ! state.showOTPModal;
        },
        sessionExpired(state, expired) {
            state.sessionExpired = expired;
        }
    },
    actions: {
        async setUser({ commit }) {
            let response = await http.get('user')

            commit('setUser', response.data)

            return response
        },
        async signup({ commit }, payload) {
            let response = await http.post('signup', payload)

            commit('login', response.data)

            return response
        },
        async login({ commit }, payload) {
            return await http.get('sanctum/csrf-cookie')
                             .then(async () => {
                                 const response = await http.post('login', payload);
                                 
                                 commit('login', response.data);

                                 return response;
                             });
        },
        async logout({ commit, dispatch }) {
            let response = await http.post('logout')

            commit('logout')
        },
        async passwordRemind({ commit }, payload) {
            return await http.post('/password/remind', payload)
        },
        async passwordReset({ commit }, payload) {
            let response = await http.post('/password/reset', payload)            

            return response
        },
        async confirmEmail({ commit, rootState }) {
            let response = await http.post('/confirm/email', rootState.route.params)

            commit('login', response.data)

            return response
        },
        async resendEmailConfirmation({ commit }) {
            return await http.post('/confirm/email/resend')
        }
    }
}